export const windowSizes = {
  monitor: {
    width: 1200,
  },
  tablet: {
    width: 991,
  },
  mobile: {
    width: 768,
  },
};
